var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['expandable-card-body',
     {
       'expandable-card-body--visible': _vm.visible
     }

    ]},[_c('div',{staticClass:"expandable-card-body__inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }